import Image from "next/image";
import React from "react";

const TextImage = ({ image, className }) => {
  if (!image) return null;

  const { filename, alt } = image;

  return (
    <div
      className={`content-center w-full h-auto md:h-96 lg:h-full overflow-hidden ${className} aspect-w-12 aspect-h-5`}
    >
      <Image
        src={`${filename}/m/1000x400`}
        alt={alt || "Image next to text"}
        fill
        style={{ objectFit: "cover" }}
        priority
        className=""
      />
    </div>
  );
};

export default TextImage;
